import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@fortawesome/fontawesome-svg-core";
import "./course.survey.cmp.scss";
import { useTranslation } from "react-i18next";

const RATING_VALUES = [1, 2, 3, 4, 5];

const CourseSurveyCmp = ({
  courseId,
  innerRef,
  afterSubmitting,
  submitFeedback,
}) => {
  const { t } = useTranslation();
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [permissionToPublish, setPermissionToPublish] = useState(false);
  const [ratingError, setRatingError] = useState("");
  const [feedbackError, setFeedbackError] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();

    const feedbackText = feedback.trim();
    if (!rating) {
      setRatingError(t("course.survey.ratingRequired"));
      return;
    }

    if (!feedbackText) {
      setFeedbackError(t("course.survey.feedbackRequired"));
      return;
    }

    setRatingError("");
    setFeedbackError("");
    await submitFeedback({
      courseId,
      rating,
      feedback: feedbackText,
      permissionToPublish,
    });

    if (afterSubmitting) afterSubmitting();
  };

  return (
    <form onSubmit={onSubmit} ref={innerRef} className="course-survey">
      <div className="course-survey__intro">
        <p>
          {t("course.survey.intro")}
        </p>
      </div>

      <div className="course-survey__rating-label">{t("course.survey.rating")}</div>
      <div
        className="course-survey__rating"
        role="radiogroup"
        aria-label={t("course.survey.ratingAria")}
        aria-invalid={Boolean(ratingError)}
        aria-describedby={ratingError ? "course-rating-error" : undefined}
      >
        {RATING_VALUES.map((value) => (
          <button
            key={value}
            type="button"
            className={`course-survey__star ${
              value <= rating ? "course-survey__star--active" : ""
            }`}
            aria-label={t("course.survey.stars", { count: value })}
            aria-checked={rating === value}
            role="radio"
            onClick={() => {
              setRating(value);
              if (ratingError) setRatingError("");
            }}
          >
            <FontAwesomeIcon icon={faStar as Icon} />
          </button>
        ))}
      </div>
      {ratingError ? (
        <div className="course-survey__error" id="course-rating-error" role="alert">{ratingError}</div>
      ) : null}

      <label className="course-survey__label" htmlFor="course-feedback">
        {t("course.survey.feedback")}
      </label>
      <textarea
        id="course-feedback"
        value={feedback}
        onChange={(event) => {
          setFeedback(event.target.value);
          if (feedbackError) setFeedbackError("");
        }}
        placeholder={t("course.survey.placeholder")}
        required
        aria-invalid={Boolean(feedbackError)}
        aria-describedby={feedbackError ? "course-feedback-error" : undefined}
        rows={6}
      />
      {feedbackError ? (
        <div className="course-survey__error" id="course-feedback-error" role="alert">{feedbackError}</div>
      ) : null}

      <label className="course-survey__permission">
        <input
          type="checkbox"
          checked={permissionToPublish}
          onChange={(event) => setPermissionToPublish(event.target.checked)}
        />
        <span>
          {t("course.survey.permission")}
        </span>
      </label>
    </form>
  );
};

export default CourseSurveyCmp;
